<mat-card-header>
	<mat-card-title>
		Deduplication History


		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>

<div class="margin-top-md" *ngIf="!isLoading && duplicateResolutions && duplicateResolutions.length > 0">
	<div *ngFor="let dr of duplicateResolutionsSlice; let i = index;" class="margin-top-md">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>{{dr.DUPLICATE_RESOLUTION_TYPES.TYPE}} - Created by <span
						class="primary">{{dr.CREATED_BY}}</span> on
					{{dr.CREATED_DATE|cleanDate|simpleDate}}</mat-card-title>
				<mat-card-subtitle>{{dr.MODIFIED_BY ? 'Updated by ' : ''}}
					<span class="primary">{{dr.MODIFIED_BY ? dr.MODIFIED_BY : ''}}</span>
					{{dr.MODIFIED_BY ? ' on ' +
					(dr.MODIFIED_DATE|cleanDate|simpleDateTime) : ''}}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<div class="table-responsive margin-top-sm" *ngIf="!isLoading">
					<mat-table [dataSource]="duplicateResolutionStudentsDataSources[i]" class="mat-elevation-z1">

						<ng-container matColumnDef="EDIT">
							<mat-header-cell *matHeaderCellDef>
								<children-deduplication-compare-btn
									[studentId1]="dr.DUPLICATE_RESOLUTION_STUDENTS[0].STUDENTS_ID"
									[studentId2]="dr.DUPLICATE_RESOLUTION_STUDENTS[1].STUDENTS_ID"></children-deduplication-compare-btn>
							</mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div aria-label="Modifed By" matTooltipClass="bigger-tooltip" class="primary"
									[matTooltip]="(element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_DATE|simpleDateTime)"
									matTooltipPosition="above"
									[matTooltipDisabled]="!element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY || element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY === ''">
									{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE">
							<mat-header-cell *matHeaderCellDef> Region </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS ?
								element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE : ''}}
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS">
							<mat-header-cell *matHeaderCellDef> Resolved </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div [ngClass]="{
										'primary italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Same'
										, 'warn italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Different'
										, 'italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Undecided'
										, 'bold': true
									}">
									{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS ?
									element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS
									: ''}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.MSD_NUMBER">
							<mat-header-cell *matHeaderCellDef> MSD # </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div [ngClass]="{'line-through': element.STUDENT.DUPLICATE_DEACTIVATE > 0}">
									{{element.STUDENT.MSD_NUMBER}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.PERSON.LAST_NAME">
							<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<edit-child-modal-btn [studentId]="element.STUDENT.ID" [type]="'string'"
									[displayText]="element.STUDENT.NAME">
								</edit-child-modal-btn>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.DOB">
							<mat-header-cell *matHeaderCellDef> DOB </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.DOB | simpleDate}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.MULTI_BIRTH">
							<mat-header-cell *matHeaderCellDef> MB </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.MULTI_BIRTH}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.BIRTH_VERIFY">
							<mat-header-cell *matHeaderCellDef> BV </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.BIRTH_VERIFY}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.BIRTH_CITY">
							<mat-header-cell *matHeaderCellDef> Birth City </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.BIRTH_CITY | titlecase}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.SEX">
							<mat-header-cell *matHeaderCellDef> Gender </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.SEX}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.LEGAL_MOTHERS[0].FIRST_NAME">
							<mat-header-cell *matHeaderCellDef> Mother (Legal P/G 2) </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									<ul>
										<li *ngFor="let item of element.STUDENT.LEGAL_MOTHERS">{{item.FIRST_NAME |
											titlecase}}
											{{item.LAST_NAME | titlecase}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.LEGAL_FATHERS[0].FIRST_NAME">
							<mat-header-cell *matHeaderCellDef> Father (Legal P/G 1) </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div>
									<ul>
										<li *ngFor="let item of element.STUDENT.LEGAL_FATHERS">{{item.FIRST_NAME |
											titlecase}}
											{{item.LAST_NAME | titlecase}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="DUPLICATE_RESOLUTION_STUDENT_PROPERTIES[0].DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE">
							<mat-header-cell *matHeaderCellDef> Reason </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div>
									<ul>
										<li *ngFor="let item of element.DUPLICATE_RESOLUTION_STUDENT_PROPERTIES">
											{{item.DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<mat-paginator [length]="duplicateResolutionsDataSource.filteredData.length" [pageSize]="pageSize"
		[pageSizeOptions]="[5, 10, 20, (duplicateResolutionsDataSource.data ? duplicateResolutionsDataSource.data.length > 100 ? duplicateResolutionsDataSource.data.length : 100 : 100)]"
		(page)="onPageChange($event)" showFirstLastButtons>
	</mat-paginator>

</div>